'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, labelName, metric1Name, metric2Name) {
  var yMin = d3.min(data, function (d) {
    return _.min([0, d[metric1Name], d[metric2Name]]);
  });
  var yMax = d3.max(data, function (d) {
    return _.max([0, d[metric1Name], d[metric2Name]]);
  });
  var x = d3.scale.ordinal().domain(_.map(data, labelName)).rangeBands([0, params.width], 0.1, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).rangeRound([params.height, 0]).nice();
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;